import { render, staticRenderFns } from "./UserInformation.vue?vue&type=template&id=cb4b0bd0&scoped=true"
import script from "./UserInformation.vue?vue&type=script&lang=js"
export * from "./UserInformation.vue?vue&type=script&lang=js"
import style0 from "./UserInformation.vue?vue&type=style&index=0&id=cb4b0bd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4b0bd0",
  null
  
)

export default component.exports